import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

const URL = "/api/notes/icd/list";

/**
 * Query ICD codes
 */
export default async function queryICDCodes(): Promise<ICDCodesList> {
  const res = await fetchOrchidAPI(
    URL + `?${Math.round(new Date().getTime() / 1000 / 60 / 60)}`,
  );
  if (!res.ok) {
    throw new Error(
      `failed to query icd codes: ${getErrorDetail(await res.text())}`,
    );
  }

  return res.json();
}
